import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MsalRedirectComponent } from '@azure/msal-angular';
import { AppShellModule } from '@schaeffler/app-shell';
import { SharedTranslocoModule } from '@schaeffler/transloco';

import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';

import { TranslocoModule } from '@ngneat/transloco';

import { PushModule } from '@ngrx/component';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AppComponent } from './app.component';

import { ApplicationInsightsModule } from '@schaeffler/application-insights';

import { NgxEchartsModule } from 'ngx-echarts';

import {
  AzureConfig,
  MsalGuardConfig,
  MsalInstanceConfig,
  MsalInterceptorConfig,
  ProtectedResource,
  SharedAzureAuthModule,
} from '@schaeffler/azure-auth';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from "@angular/material/divider";

const azureConfig = new AzureConfig(
  new MsalInstanceConfig(
    environment.clientId,
    environment.tenantId,
    !environment.production
  ),
  new MsalInterceptorConfig([
    new ProtectedResource('/api/*', [environment.appId]),
  ]),
  new MsalGuardConfig('/forbidden', [environment.appId])
);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    TranslocoModule,
    // Translation
    SharedTranslocoModule.forRoot(environment.production, ['en', 'de'], 'en', // default -> undefined would lead to browser detection
    'en', 'language', // language storage key -> language is not persisted in this app
    true, false),
    // UI Modules
    AppShellModule,
    StoreModule.forRoot({}, {
        metaReducers: !environment.production ? [] : [],
        runtimeChecks: {
            strictActionImmutability: true,
            strictStateImmutability: true,
        },
    }),
    EffectsModule.forRoot([]),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    PushModule,
    SharedAzureAuthModule.forRoot(azureConfig),
    MatIconModule,
    ApplicationInsightsModule.forRoot(environment.applicationInsights),
    NgxEchartsModule.forRoot({
        echarts: () => import('echarts')
    }),
    MatDividerModule
],
  providers: [
    {
      provide: ErrorHandler,
      useClass: ErrorHandler
    }
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {}
